var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "panel-group", attrs: { gutter: 40 } },
    [
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, lg: 8 } },
        [
          _c("div", { staticClass: "card-panel" }, [
            _c(
              "div",
              { staticClass: "card-panel-icon-wrapper icon-people" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": _vm.statistics.first.icon,
                    "class-name": "card-panel-icon"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-panel-description" },
              [
                _c("div", { staticClass: "card-panel-text" }, [
                  _vm._v(_vm._s(_vm.statistics.first.name))
                ]),
                _vm._v(" "),
                _c("count-to", {
                  staticClass: "card-panel-num",
                  attrs: {
                    "start-val": 0,
                    "end-val": _vm.statistics.first.num,
                    duration: 2600
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, lg: 8 } },
        [
          _c("div", { staticClass: "card-panel" }, [
            _c(
              "div",
              { staticClass: "card-panel-icon-wrapper icon-message" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": _vm.statistics.second.icon,
                    "class-name": "card-panel-icon"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-panel-description" },
              [
                _c("div", { staticClass: "card-panel-text" }, [
                  _vm._v(_vm._s(_vm.statistics.second.name))
                ]),
                _vm._v(" "),
                _c("count-to", {
                  staticClass: "card-panel-num",
                  attrs: {
                    "start-val": 0,
                    "end-val": _vm.statistics.second.num,
                    duration: 3000
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, lg: 8 } },
        [
          _c("div", { staticClass: "card-panel" }, [
            _c(
              "div",
              { staticClass: "card-panel-icon-wrapper icon-money" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": _vm.statistics.third.icon,
                    "class-name": "card-panel-icon"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-panel-description" },
              [
                _c("div", { staticClass: "card-panel-text" }, [
                  _vm._v(_vm._s(_vm.statistics.third.name))
                ]),
                _vm._v(" "),
                _c("count-to", {
                  staticClass: "card-panel-num",
                  attrs: {
                    "start-val": 0,
                    "end-val": _vm.statistics.third.num,
                    duration: 3200
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }